import React, { useEffect, useRef, useState } from "react";

const TickValue = ({
  value,
  toFixed,
  useSeparator,
}: {
  value: number;
  toFixed?: number;
  useSeparator?: boolean;
}) => {
  const [number, setNumber] = useState(0);
  const numRef = useRef(0);
  useEffect(() => {
    const originalDiference = value - numRef.current;

    if (originalDiference === 0) setNumber(value);
    else {
      const interval = setInterval(() => {
        const prev = numRef.current;
        let next = 0;

        if (originalDiference > 0) {
          //counting up
          if (prev > value - value / 20) {
            clearInterval(interval);
            next = value;
          } else next = numRef.current + originalDiference / 20;
        } else {
          //counting down..
          if (prev < value + value / 20) {
            clearInterval(interval);
            next = value;
          } else next = next = numRef.current + originalDiference / 20;
        }
        setNumber(next);
        numRef.current = next;
      }, 50);
      return () => {
        clearInterval(interval);
      };
    }
  }, [value]);
  let displayVal = toFixed !== undefined ? number.toFixed(toFixed) : Math.round(number);
  if (useSeparator) displayVal = numberWithSepartor(displayVal);
  return <>{displayVal}</>;
};

export default TickValue;

function numberWithSepartor(x: number | string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
